import React from 'react';

export default function FilterDati(props) {
  return (
    <div className='table-title'>
      <div className='row'>
        <div className='col-sm-5'>
          <h2>
            Risultati Ricerca: <small>Trovati {props.numcli} Clienti</small>
          </h2>
        </div>
        <div className='col-sm-7'>
          <button
            style={{ marginleft: '20px' }}
            className='btn btn-success float-right'
            onClick={props.Inserisci}
          >
            <i className='fa fa-plus'></i> Nuovo Utente
          </button>
        </div>
      </div>
    </div>
  );
}
